/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import authSlice from 'slices/authSlice';
import {history} from 'utils/history'


const appReducer = combineReducers({
  router: connectRouter(history),
  auth: authSlice
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: Action,
): RootState => {
//   if (action.type === logout.type) {
//     localStorage.removeItem('accessToken');
//     state = undefined;
//   }
  return appReducer(state, action);
};

export default rootReducer;
